import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredVolatilityLow = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 9 14"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M2.74486 5.33811L3.69204 4.29948L5.07223 5.31893C5.12026 4.9525 5.10059 4.57916 5.01386 4.22098C4.9143 3.7524 4.69096 3.32486 4.37096 2.98988C4.05096 2.6549 3.64795 2.42674 3.21038 2.33307C3.26606 2.0476 3.38218 1.77974 3.54984 1.55047C3.82679 1.21259 4.22296 1.0161 4.64129 1.00897L4.56925 0C4.2358 0.0124894 3.90855 0.0996924 3.608 0.25581C3.30766 0.411928 3.04065 0.633838 2.82393 0.907045C2.52566 1.31518 2.33068 1.79982 2.25782 2.31344C0.25832 2.63861 0 4.90879 0 4.90879L1.60995 4.08159L2.74486 5.33811Z"
      fill="url(#paint0_linear_7560_29774)"
    />
    <path
      d="M8.13752 12.2472L8.09219 12.2283C7.35283 11.9283 6.68364 11.4568 6.13201 10.8471C5.65263 10.2944 5.29392 9.63313 5.08258 8.91142C4.86608 8.28539 4.73153 7.6297 4.68289 6.96352C4.65867 6.5284 4.66447 6.09193 4.70028 5.65748L3.75083 4.95651L2.74238 6.06205L1.50832 4.69513L0.316486 5.30555C0.209267 6.04867 0.205333 6.80472 0.304894 7.54918C0.481041 8.88444 0.991473 10.143 1.78155 11.1894C2.55671 12.1779 3.54839 12.9426 4.66695 13.4139C4.92983 13.533 5.19995 13.6322 5.47545 13.7114C5.74225 13.7997 6.01444 13.8673 6.29015 13.9139C6.82977 14.0073 7.37849 14.0247 7.92225 13.9661C8.17063 13.9389 8.39439 13.7926 8.53121 13.5675C8.66803 13.3425 8.70342 13.063 8.62725 12.8068C8.55129 12.5505 8.37183 12.3451 8.13917 12.2474L8.13752 12.2472Z"
      fill="url(#paint1_linear_7560_29774)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7560_29774"
        x1={2.88889}
        y1={0}
        x2={2.88889}
        y2={14}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF347" />
        <stop offset={1} stopColor="#ED023B" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_7560_29774"
        x1={2.88889}
        y1={0}
        x2={2.88889}
        y2={14}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF347" />
        <stop offset={1} stopColor="#ED023B" />
      </linearGradient>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgColouredVolatilityLow)
const IconSvgColouredVolatilityLow = createIcon(
  ForwardRef,
  'SvgColouredVolatilityLow',
)
export default IconSvgColouredVolatilityLow
